import React from 'react';
import { arrayOf, object, shape, string } from 'prop-types';
import LandingLink from './LandingLink';

/**
 * Page hero: breadcrumb, H1, lead paragraph, CTAs and the short geo line.
 *
 * `tagline` renders through the existing .hero-geo class. It is omitted rather
 * than emptied when absent, so a page with no tagline has no stray element.
 */
const Hero = props => {
  const { crumbs, heading, lead, tagline, primaryCta, secondaryCta } = props;

  return (
    <section className="hero" aria-labelledby="hero-title">
      <div className="container hero-inner">
        <nav className="breadcrumb" aria-label="Brotkrumen">
          {crumbs.map((crumb, i) => (
            <React.Fragment key={crumb.label}>
              {i > 0 ? <span className="sep">/</span> : null}
              {crumb.link ? (
                <LandingLink link={crumb.link}>{crumb.label}</LandingLink>
              ) : (
                <span aria-current="page">{crumb.label}</span>
              )}
            </React.Fragment>
          ))}
        </nav>
        <h1 id="hero-title">{heading}</h1>
        {lead ? <p className="lead">{lead}</p> : null}
        <div className="hero-ctas">
          <LandingLink className="btn btn-primary" link={primaryCta.link}>
            {primaryCta.label}
          </LandingLink>
          {secondaryCta ? (
            <LandingLink className="btn btn-ghost" link={secondaryCta.link}>
              {secondaryCta.label}
            </LandingLink>
          ) : null}
        </div>
        {tagline ? <p className="hero-geo">{tagline}</p> : null}
      </div>
    </section>
  );
};

Hero.propTypes = {
  crumbs: arrayOf(shape({ label: string.isRequired, link: object })).isRequired,
  heading: string.isRequired,
  lead: string,
  tagline: string,
  primaryCta: shape({ link: object.isRequired, label: string.isRequired }).isRequired,
  secondaryCta: shape({ link: object, label: string }),
};

export default Hero;
